import { render, staticRenderFns } from "./AuditLogTable.vue?vue&type=template&id=94623d08&scoped=true&"
import script from "./AuditLogTable.vue?vue&type=script&lang=js&"
export * from "./AuditLogTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogTable.vue?vue&type=style&index=0&id=94623d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94623d08",
  null
  
)

export default component.exports